/**
 * epgAnchorContainer.tsx
 */
import withOpacity from '@shared/components/utils/hoc/withOpacity';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const EpgAnchorContainer = styled.div<
  React.CSSProperties & { focused?: boolean }
>`
  background: linear-gradient(
    165deg,
    #181818 46.89%,
    rgba(116, 116, 116, 0) 115.78%
  );
  align-items: center;
  display: flex;
  float: left;
  justify-content: center;
  border: 2px solid #7e7e7e;
  border-radius: ${20 * Screen.widthRatio}px;
  margin-right: ${12 * Screen.widthRatio}px;
  height: ${76 * Screen.widthRatio}px;
  width: ${76 * Screen.widthRatio}px;
`;

export default withOpacity(EpgAnchorContainer);
